'use client'
import { usePathname } from '@/i18n/navigation'
import { useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'

import { GeneralTabs } from './general-tabs'

export function Wrapper() {
  const [categoryId, setCategoryId] = useState<string>('legal-acts')

  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {}, [pathname, searchParams])

  const handleCategoryChange = (categoryId: string) => {
    if (categoryId) setCategoryId(categoryId)
  }

  return (
    <div className="mx-auto max-w-245 space-y-12 pt-8 md:pt-24">
      <GeneralTabs
        onSelectTab={handleCategoryChange}
        selectedTab={categoryId}
      />
    </div>
  )
}
